module.exports = __webpack_public_path__ + "img/mic5.b8a963fe.jpg";